export interface MultiOption {
  model: string | number;
  label: string;
  selected?: boolean;
  disabled?: boolean;
  unavailable?: boolean;
  loading?: boolean;
  activeCount: number;
  options?: MultiSubOptions | MultiOption[];
  pagination?: boolean;
  paginationLoading?: boolean;
  searchTerm?: string;
  placeholder?: string;
  selectedOption?: string;
  comparingOption?: string;
  type: "INPUT" | "DROPDOWN" | "COMPARISON";
  inputType?: string;
  isAdminOnly?: boolean;
  singleValue?: boolean;
}

export interface MultiSubOption
  extends Omit<
    MultiOption,
    | "loading"
    | "activeCount"
    | "options"
    | "pagination"
    | "paginationLoading"
    | "type"
  > {
  unavailable?: boolean;
}

export type MultiOptions = MultiOption[];
export type MultiSubOptions = MultiSubOption[];

export enum FilterInputType {
  Number = 'number',
  Text = 'text',
}

export enum FilterType {
  Dropdown = 'DROPDOWN',
  Input = 'INPUT',
  Comparison = 'COMPARISON',
}
